import { render, staticRenderFns } from "./CompareMatches.vue?vue&type=template&id=c4c1bd82&scoped=true&"
import script from "./CompareMatches.vue?vue&type=script&lang=js&"
export * from "./CompareMatches.vue?vue&type=script&lang=js&"
import style0 from "./CompareMatches.vue?vue&type=style&index=0&id=c4c1bd82&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4c1bd82",
  null
  
)

export default component.exports